import React, { memo } from 'react';
import { Icon } from './../../../components/icon';
import { NotificationPane } from '../notificationPane';
export function NotificationStatusBarView(props) {
    const { data = [], onClick, showNotifications, id, actionBar, onActionBarClick, onCloseNotification, } = props;
    const hasNotifications = data.length > 0;
    const renderIcon = hasNotifications ? 'bell-dot' : 'bell';
    return (React.createElement(React.Fragment, null,
        React.createElement(Icon, { onClick: onClick, type: renderIcon }),
        React.createElement(NotificationPane, { id: id, data: data, actionBar: actionBar, showNotifications: showNotifications, onActionBarClick: onActionBarClick, onCloseNotification: onCloseNotification })));
}
export default memo(NotificationStatusBarView);
